export default {
  Illustrations: 'Illustrations',
  Cardiology: 'Cardiologie',
  Neurology: 'Neurologie',
  Surgery: 'Chirurgie',
  Urology: 'Urologie',
  Gynecology: 'Gynécologie',
  Obstetrics: 'Obstétrique',
  Clinician: 'Clinicien',
  Pneumonology: 'Pneumonologie',
  Endocrinology: 'Endocrinologie',
  Orthopedics: 'Orthopédie',
  Pediatrics: 'Pédiatrie',
  Hematology: 'Hématologie',
  Immunology: 'Immunologie',
  Parasitology: 'Parasitologie',
  Nutrition: 'Nutrition',
  Odontology: 'Odontologie',
  Pharmacy: 'Pharmacie',
  Nursing: 'Soins infirmiers',
  Veterinary: 'Vétérinaire',
  Zoology: 'Zoologie',
  Botany: 'Botanique',
  'Cell biology': 'Biologie cellulaire',
  Development: 'Développement',
  Entomology: 'Entomologie',
  Ornithology: 'Ornithologie',
  Biochemistry: 'Biochimie',
  Chemistry: 'Chimie',
  Genetics: 'Génétique',
  'Molecular Biology': 'Biologie moléculaire',
  Nanotechnology: 'Nanotechnologie',
  Neuroscience: 'Neurosciences',
  Pharmacology: 'Pharmacologie',
  Toxicology: 'Toxicologie',
  'Earth Sciences': 'Sciences de la Terre',
  Education: 'Éducation',
  Engineering: 'Ingénierie',
  Geography: 'Géographie',
  'Physics & Astronomy': 'Physique et Astronomie',
  Oceanography: 'Océanographie',
  'Marine biology': 'Biologie marine',
  History: 'Histoire',
  'Others - Molecular Sciences': 'Autres - Sciences Moléculaires',
  Others: 'Autres',
};
